"use client";
import Cookies from "js-cookie";
import { getEnv } from "@/env";

/**
 * Logs out if the user info cookie is missing while either one of the JWT cookies are present.
 * This cleans up inconsistent auth state where tokens exist but user info is absent.
 *
 * @returns true if logout is needed; false otherwise
 */
export default function shouldLogOutUser(): boolean {
  const userInfoCookieName = getEnv("NEXT_PUBLIC_USER_INFO_COOKIE_NAME");
  const hasUserInfoCookie = !!Cookies.get(userInfoCookieName);

  if (hasUserInfoCookie) return false;

  const accessTokenCookieName = getEnv("NEXT_PUBLIC_ACCESS_TOKEN_COOKIE_NAME");
  const signatureCookieName = getEnv("NEXT_PUBLIC_SIGNATURE_COOKIE_NAME");
  const hasAccessToken = !!Cookies.get(accessTokenCookieName);
  const hasSignature = !!Cookies.get(signatureCookieName);
  const shouldLogout = !hasUserInfoCookie && (hasAccessToken || hasSignature);

  return shouldLogout;
}
